import router from './router';

import App from './App.svelte';

const app = new App({
  target: document.body,
  hydrate: true,
  props: {
    router,
  },
});

export default app;
